import ScreenDesignerListHoc from "./ScreenDesignerListHoc";

export default ScreenDesignerListHoc;